<template>
  <v-container fluid class="ma-0 pa-0">
    <v-col class="ma-0 pa-2 pt-4" cols="12">
      <v-col class="ma-0 pa-0 mb-3" cols="12" align="center">
        <div style="font-size: 1.1rem; font-weight: bold; margin-bottom: 1rem;">{{'Device Performance'}}</div>
        <v-btn width="100%" height="2.5rem" id="blue_btn"
          @click="refreshPerformance">
          {{'refresh'}}
        </v-btn>
      </v-col>

      <v-col class="ma-0 pa-0 mt-4" cols="12">
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0" cols="12">
            <v-card dark class="pa-4 mb-4" style="background-color: #1E1E1E; border: 1px solid #4A4A4A;">
              <v-card-title class="pa-0 mb-3" style="color: white; font-size: 1rem;">
                {{'Hardware Concurrency'}}
              </v-card-title>
              <v-card-text class="pa-0" style="color: white; font-size: 1.1rem; font-weight: bold;">
                {{hardwareConcurrency}} {{'cores'}}
              </v-card-text>
              <v-card-text class="pa-0 mt-2" style="color: #8E8E8E; font-size: 0.8rem;">
                {{'Logical CPU core count'}}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="ma-0 pa-0 mt-4" cols="12">
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0" cols="12">
            <v-card dark class="pa-4 mb-4" style="background-color: #1E1E1E; border: 1px solid #4A4A4A;">
              <v-card-title class="pa-0 mb-3" style="color: white; font-size: 1rem;">
                {{'VideoJS VHS'}}
              </v-card-title>
              <v-card-text class="pa-0" style="color: white; font-size: 1.1rem; font-weight: bold;">
                {{recentVhsBandwidth}} {{'Mbps'}}
              </v-card-text>
              <v-card-text class="pa-0 mt-2" style="color: #8E8E8E; font-size: 0.8rem;">
                {{'recent vhs bandwidth'}}
              </v-card-text>
              <v-card-text class="pa-0" style="color: white; font-size: 1.1rem; font-weight: bold;">
                {{recentVhsThroughput}} {{'Mbps'}}
              </v-card-text>
              <v-card-text class="pa-0 mt-2" style="color: #8E8E8E; font-size: 0.8rem;">
                {{'recent vhs throughput'}}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="ma-0 pa-0 mt-4" cols="12">
        <v-card dark class="pa-4" style="background-color: #1E1E1E; border: 1px solid #4A4A4A;">
          <v-card-title class="pa-0 mb-4" style="color: white; font-size: 1rem;">
            {{'Network connection information'}}
          </v-card-title>
          <v-row class="ma-0 pa-0">
            <v-col class="ma-0 pa-0" cols="12">
              <v-card-text class="pa-0 mb-2" style="color: #8E8E8E; font-size: 0.85rem;">
                {{'Connection speed grade'}}
              </v-card-text>
              <v-card-text class="pa-0 mb-4" style="color: white; font-size: 1rem; font-weight: bold;">
                {{effectiveType || 'N/A'}}
              </v-card-text>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <v-card-text class="pa-0 mb-2" style="color: #8E8E8E; font-size: 0.85rem;">
                {{'Download speed'}}
              </v-card-text>
              <v-card-text class="pa-0 mb-4" style="color: white; font-size: 1rem; font-weight: bold;">
                {{downlink ? downlink + ' Mbps' : 'N/A'}}
              </v-card-text>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <v-card-text class="pa-0 mb-2" style="color: #8E8E8E; font-size: 0.85rem;">
                {{'Round-trip time (RTT)'}}
              </v-card-text>
              <v-card-text class="pa-0 mb-4" style="color: white; font-size: 1rem; font-weight: bold;">
                {{rtt ? rtt + ' ms' : 'N/A'}}
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col class="ma-0 pa-0 mt-4" cols="12">
        <v-card dark class="pa-4" style="background-color: #1E1E1E; border: 1px solid #4A4A4A;">
          <v-card-title class="pa-0 mb-4" style="color: white; font-size: 1rem;">
            {{'Additional information'}}
          </v-card-title>
          <v-row class="ma-0 pa-0">
            <v-col class="ma-0 pa-0" cols="12">
              <v-card-text class="pa-0 mb-2" style="color: #8E8E8E; font-size: 0.85rem;">
                {{'User Agent (UA)'}}
              </v-card-text>
              <v-card-text class="pa-0 mb-4" style="color: white; font-size: 0.85rem; word-break: break-all;">
                {{userAgent}}
              </v-card-text>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <v-card-text class="pa-0 mb-2" style="color: #8E8E8E; font-size: 0.85rem;">
                {{'Screen resolution'}}
              </v-card-text>
              <v-card-text class="pa-0 mb-4" style="color: white; font-size: 0.85rem;">
                {{screenResolution}}
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-col>
  </v-container>
</template>

<script>
import mixin from '@/mixin';
import MobileAppBar from './components/MobileAppBar.vue';

export default {
  components: {
    MobileAppBar
  },
  mixins: [mixin.common],
  data: () => ({
    appbarTitle: 'Device Performance',
    hardwareConcurrency: 0,
    recentVhsBandwidth: 0,
    recentVhsThroughput: 0,
    effectiveType: 'N/A',
    downlink: null,
    rtt: null,
    userAgent: '',
    screenResolution: '',
    updateInterval: null
  }),
  mounted() {
    this.updateInterval = setInterval(() => {
      console.log('%cMobile DevicePerformance updateInterval', "color:#008DD0;");
      this.collectPerformanceData();
    }, 1000);
  },
  beforeDestroy() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
  methods: {
    collectPerformanceData() {
      // Hardware Concurrency
      this.hardwareConcurrency = navigator.hardwareConcurrency || 0;
      // VideoJS VHS
      const vhs = localStorage.getItem("videojs-vhs");
      const mbps_unit = 1000000;
      if (vhs) {
        const obj = JSON.parse(vhs);  
        this.recentVhsBandwidth = obj.bandwidth / mbps_unit;
        this.recentVhsThroughput = obj.throughput / mbps_unit;
      }
      // Network Information API
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection) {
        this.effectiveType = connection.effectiveType || 'N/A';
        this.downlink = connection.downlink ? connection.downlink.toFixed(2) : null;
        this.rtt = connection.rtt || null;
      } else {
        this.effectiveType = 'N/A';
        this.downlink = null;
        this.rtt = null;
      }
      // User Agent
      this.userAgent = navigator.userAgent || 'N/A';
      // Screen Resolution
      this.screenResolution = `${window.screen.width} x ${window.screen.height}`;
      
    },
    refreshPerformance() {
      this.collectPerformanceData();
      this.$dialog.message.info('성능 데이터를 새로고침했습니다', {
        position: 'top', timeout: 2000
      });
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-card {
    border-radius: 4px;
  }
}
</style>

